RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _, async) {

    'use strict';

    views.Edit = Marionette.LayoutView.extend({
        template: '#adminCompanyEditTemplate',

        regions: {
            socialChannels: '#socialChannels',
            trackedPages: '#trackedPages',
            editHistory: '#editHistory',
            finderFlags: '#finderFlags',
            customerChangeRequests: '#customerChangeRequests',
            finderStatus: '#finderStatus',
            fieldEditor: '#fieldEditor'
        },

        ui: {
            buttons: '.btn',
            saveBtn: '.x-save',
            saveAndFindBtn: '.x-save-and-find',
            cancelBtn: '.x-cancel',
            updateDataLink: '.x-update-data',
            deleteLink: '.x-delete-company',
            editLink: '.x-edit-company',
            clearAllFinderBtn: '.x-clear-finder'
        },

        events: {
            'click @ui.saveBtn': 'saveAndRedirect',
            'click @ui.saveAndFindBtn': 'saveAndFindChannels',
            'click @ui.cancelBtn': 'cancelEditing',
            'click @ui.updateDataLink': 'updateExternalData',
            'click @ui.deleteLink': 'deleteCompany',
            'click @ui.clearAllFinderBtn': 'clearAllFinderFlags'
        },

        onRender: function () {
            const me = this;

            me.ui.buttons.button('loading');

            me.fieldEditor.show(new views.FieldEditor({
                model: me.model
            }));

            me.finderStatus.show(new views.FinderStatus({
                model: me.model
            }));

            me.socialChannels.show(new views.SocialChannels({
                model: me.model,
                collection: me.model.get('socialChannels')
            }));

            const changeRequestDeferred = me.loadChangeRequests();
            changeRequestDeferred.done(function () {
                me.customerChangeRequests.show(new views.CustomerChangeRequests({
                    collection: me.model.get('changeRequests')
                }));
            });

            const trackedPageDeferred = me.loadTrackedPages();
            trackedPageDeferred.done(function () {
                me.trackedPages.show(new views.TrackedPages({
                    model: me.model,
                    collection: me.model.get('urls')
                }));
            });

            me.loadEditHistory(function (editHistoryCollection) {
                me.editHistory.show(new views.EditHistory({
                    collection: editHistoryCollection
                }));
            });

            $.when(changeRequestDeferred, trackedPageDeferred)
                .done(function () {
                    me.ui.buttons.button('reset');
                });
        },

        loadChangeRequests: function () {
            const me = this;

            me.customerChangeRequests.showLoading();

            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    return me.customerChangeRequests.showError();
                }
            });

            if (me.model.has('changeRequests')) {
                deferred.resolve();
                return deferred;
            }

            me.model.set('changeRequests', new RivalIQ.apps.Admin.collections.CustomerChangeRequests({}, {
                companyId: me.model.get('id')
            }));

            me.model.get('changeRequests').fetch({
                companyId: me.model.get('id')
            }).done(deferred.resolve).fail(deferred.reject);

            return deferred;
        },

        loadTrackedPages: function () {
            const me = this;

            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    return me.trackedPages.showError();
                }
            });

            if (me.model.has('urls')) {
                deferred.resolve();
                return deferred;
            }

            me.trackedPages.showLoading();

            me.model.set('urls', new RivalIQ.apps.Admin.collections.TrackedPages({
                companyId: me.model.get('id')
            }));

            me.model.get('urls').fetch({
                companyId: me.model.get('id')
            }).done(deferred.resolve).fail(deferred.reject);

            return deferred;
        },

        loadEditHistory: function (callback) {
            const me = this;

            if (me.editHistoryCollection) {
                return callback(me.editHistoryCollection);
            }

            me.editHistory.showLoading();

            me.editHistoryCollection = new RivalIQ.apps.Admin.collections.EditHistory({
                companyId: me.model.get('id')
            });

            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    return me.editHistory.showError();
                }
                callback(me.editHistoryCollection);
            });

            me.editHistoryCollection.fetch().done(deferred.resolve).fail(deferred.reject);
        },

        updateExternalData: function () {
            const me = this;

            RivalIQ.execute('alert:info', `Updating external data for ${me.model.get('name')}`);
            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    return RivalIQ.execute('alert:danger', `An error occurred updating external data for ${me.model.get('name')}`);
                }
            });

            me.model.updateExternalData().done(deferred.resolve).fail(deferred.reject);
        },

        deleteCompany: function () {
            const me = this;

            App.companyDeleteModal.show(new views.Delete({
                model: me.model
            }));
        },

        clearAllFinderFlags: function () {
            const me = this;
            me.ui.clearAllFinderBtn.blur();
            me.model.get('socialChannels').invoke('set', {
                finderFlag: false
            });
        },

        save: function (callback) {
            const me = this;
            me.ui.buttons.button('loading');

            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    me.ui.buttons.button('reset');
                    return RivalIQ.execute('alert:error', error);
                }
                RivalIQ.execute('alert:info', `${me.model.get('name')} saved!`);

                callback(error);
            });

            me.model.save(null, {
                attrs: me.model.toAjaxJSON()
            }).done(deferred.resolve).fail(deferred.reject);
        },

        unlock: function (callback) {
            const me = this;
            const deferred = async.callbackToDeferred(function (error) {
                if (error) {
                    RivalIQ.execute('alert:error', error);
                }

                callback(error);
            });
            me.model.unlock().done(deferred.resolve).fail(deferred.reject);
        },

        saveAndRedirect: function () {
            const me = this;

            me.save(function (error) {
                if (error) {
                    return me.ui.buttons.button('reset');
                }

                me.unlock(function (error) {
                    if (!error) {
                        window.location = '#/companies';
                    }
                });
            });

        },

        saveAndFindChannels: function () {
            const me = this;
            const deferred = async.callbackToDeferred(function (error) {
                me.ui.buttons.button('reset');

                if (error) {
                    return RivalIQ.execute('alert:error', error);
                }

                RivalIQ.execute('alert:info', 'Channel finder scheduled');

                me.unlock(function (error) {
                    if (!error) {
                        window.location = '#/companies';
                    }
                });
            });

            me.save(function (error) {
                if (error) {
                    return me.ui.buttons.button('reset');
                }

                me.model.findChannels().done(deferred.resolve).fail(deferred.reject);
            });
        },

        cancelEditing: function () {
            const me = this;
            me.ui.buttons.button('loading');

            me.unlock(function (error) {
                if (error) {
                    return me.ui.cancelBtn.button('reset');
                }
                window.location = '#/companies';
                RivalIQ.execute('alert:info', 'Cancelled edits and unlocked company');
            });
        }
    });
}, RivalIQ.utils.async);
